/**
 * What: Validates uploaded Shopify image-treatment values before they become StudyRun arms.
 * Transport / data-flow: Pure shared helper used by browser draft validation and server preflight validation.
 *
 */

const CANONICAL_MEDIA_PATHS = ['/media/uploads/media/', '/api/uploads/uploads/media/']

function isCanonicalMediaPath(pathname: string) {
  return CANONICAL_MEDIA_PATHS.some((prefix) => pathname.startsWith(prefix))
}

/** Why: treatment images must resolve through TestFeed media storage during later provider execution. */
export function isCanonicalShopifyImageVariantUrl(value: string) {
  if (isCanonicalMediaPath(value)) return true
  if (!URL.canParse(value)) return false

  const url = new URL(value)
  return url.protocol === 'https:' && isCanonicalMediaPath(url.pathname)
}
